// ============================================================
//  AUTH API — ADMIN DASHBOARD
//  Path: src/api/auth.api.ts
//
//  Pure HTTP calls — maps 1:1 to backend auth.routes.js
//  Backend base path: /api/auth
//
//  ┌─────────────────────────────────────────────────────────┐
//  │  Frontend (auth.api.ts)     →  Backend (auth.routes.js) │
//  │─────────────────────────────────────────────────────────│
//  │  syncUserApi()              →  POST /sync               │
//  │  getMeApi()                 →  GET  /me                 │
//  └─────────────────────────────────────────────────────────┘
//
//  FIX (review pass): removed the console.log in getMeApi — a
//  leftover from MFA debugging that ran on every page load and
//  session restore in production. Errors still surface through
//  AuthContext's own catch.
//
//  Note: syncUserApi isn't used by the dashboard (AuthContext only
//  calls getMeApi). It's kept so nothing that imports it breaks;
//  the backend's syncUser is read-only, so it's harmless.
// ============================================================

import api from '../config/api'

// ── POST /api/auth/sync ──────────────────────────────────────
export const syncUserApi = () => api.post('/api/auth/sync')

// ── GET /api/auth/me ─────────────────────────────────────────
export const getMeApi = () => api.get('/api/auth/me')